export const ACCOUNTANT_ACTIVE_COMPANY_KEY = 'contabird.accountant.active_company';
export const ACCOUNTANT_PROFILE_KEY = 'contabird.accountant.profile';

export function getActiveAccountantCompanyId(): string | null {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem(ACCOUNTANT_ACTIVE_COMPANY_KEY);
  return value && /^[0-9a-f-]{36}$/i.test(value) ? value : null;
}

export function setActiveAccountantCompanyId(companyUserId: string) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(ACCOUNTANT_ACTIVE_COMPANY_KEY, companyUserId);
}

export function clearActiveAccountantCompanyId() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(ACCOUNTANT_ACTIVE_COMPANY_KEY);
}

export function rememberAccountantProfile(isAccountant: boolean) {
  if (typeof window === 'undefined') return;
  if (isAccountant) window.localStorage.setItem(ACCOUNTANT_PROFILE_KEY, 'true');
  else {
    window.localStorage.removeItem(ACCOUNTANT_PROFILE_KEY);
    clearActiveAccountantCompanyId();
  }
}

export function isAccountantProfileRemembered(): boolean {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(ACCOUNTANT_PROFILE_KEY) === 'true';
}

export function isAccountantWorkspaceActive(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.localStorage.getItem(ACCOUNTANT_PROFILE_KEY) === 'true'
    && Boolean(getActiveAccountantCompanyId())
  );
}
